import { render } from "./FormSignup.vue?vue&type=template&id=28554201&scoped=true"
import script from "./FormSignup.vue?vue&type=script&lang=js"
export * from "./FormSignup.vue?vue&type=script&lang=js"

import "./FormSignup.vue?vue&type=style&index=0&id=28554201&scoped=true&lang=css"

import exportComponent from "/Users/vitechasia/Documents/Kantor/project_nuxt/vuess/vtadesk-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28554201"]])

export default __exports__